import { ServiceType } from '@types';
import apiClient from './apiClient';
import { useApplicationStore } from '@data';

export async function fetchServiceTypesForPatient(): Promise<ServiceType[]> {
  const { flags } = useApplicationStore.getState();
  const isPatientVisibilityOverrideDisabled = !flags.useProviderVisibility;

  const { data } = await apiClient.get<ServiceType[]>(
    `/api/v1/serviceTypes?isPatientVisibilityOverrideDisabled=${isPatientVisibilityOverrideDisabled}`,
  );

  return data;
}
